import { Observable, of, pipe, UnaryFunction } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class Failure<T> {
  error: T;

  constructor(error: T) {
    this.error = error;
  }
}

export function catchFailure<T>(): UnaryFunction<
  Observable<T>,
  Observable<T | Failure<any>>
> {
  return pipe(catchError((e) => of(new Failure(e))));
}
